module.exports = __webpack_public_path__ + "img/clothing165.106f725e.jpg";